// Duration argument is in seconds
const formatDuration = (duration) => {
  const minutes = getMinutes(duration)
  const seconds = getSeconds(duration)
  return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`
}

const getMinutes = (duration) => {
  return Math.floor(duration / 60)
}

const getSeconds = (duration) => {
  return duration % 60
}

export { formatDuration, getMinutes, getSeconds }
